import "./DashboardSummaryRowComponent.scss";
import {IOnDestroy, IOnInit, IScope} from "angular";
import {ReplaySubject} from "rxjs";
import {RiskDashboardViewStore} from "../../../store/RiskDashboardViewStore";
import {DashboardSummaryViewRow} from "../../../models/view-model/RiskDashboardViewModel";

export const SummaryRow = "dashboardSummaryRow";

export function summaryRow() {
    return {
        templateUrl: "app/risk/dashboard/components/grid/summary/DashboardSummaryRowComponent.html",
        bindings: {
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: DashboardSummaryRowComponentController
    };
}

export class DashboardSummaryRowComponentController implements IOnInit, IOnDestroy {

    public readonly viewStore: RiskDashboardViewStore;

    public summary: DashboardSummaryViewRow;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private $scope: IScope) {

    }

    public $onInit(): void {
        this.viewStore
            .model
            .takeUntil(this.destroyed$)
            .map((m) => m.summary)
            .do((summary) => this.summary = summary)
            .do(() => this.$scope.$applyAsync())
            .subscribe();
    }

    public collapseAll() {
        this.viewStore.collapseAll();
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
